import {
  Paper,
  useTheme,
  IconButton,
  Divider,
  Tooltip,
  Popover,
  Stack,
  FormControlLabel,
  Switch,
  Typography,
  alpha,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import SubtitlesOffOutlinedIcon from "@mui/icons-material/SubtitlesOffOutlined";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import { useReactFlow } from "reactflow";
import {
  TuneOutlined,
  LabelOffOutlined,
  LabelOutlined,
  VolumeUp,
  VolumeOff,
} from "@mui/icons-material";
import { useState } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import ConfigLocalPopover from "../configLocalPopover";
import ConfiguracaoMapModal from "../configMapModal";
import { useMapa } from "../../../contexts/mapaContext";
const ToolBarMapsPublic = ({
  setFullScreem,
  fullScreem = false,
  setShowLabel,
  showLabel = true,
  setShowLabelEnlace,
  showLabelEnlace = true,
  children,
  tipo = 0,
  setEasyMapsConfig = () => {},
  easyMapsConfig,
  collapse,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const { soundState, setSoundState } = useMapa();
  const styles = {
    switch: {
      width: "100%",
      ml: "0px",
      mr: "0px",
    },
    icon: {
      color: theme.palette.color.icons,
    },
    button: {
      borderRadius: "5px",
      padding: "5px",
    },
    card: {
      padding: "5px",
      borderRadius: "6px",
      position: "absolute",
      ml: "0px",
      transition: "margin-left 0.3s ease",
      zIndex: 1,
      display: "flex",
      flexDirection: "column",
      left: "15px",
      top: "15px",
      alignItems: "center",
      gap: 0.75,
      justifyContent: "center",
      backgroundColor: theme.palette.background.default,
      border: "1px solid " + theme.palette.color.appBarBorder,
      zIndex: 10,
    },
    paper: {
      display: "flex",
      flexDirection: "column",
      gap: "2px",
      justifyContent: "center",
      alignItems: "center",
    },
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (event, path, name) => {
    setEasyMapsConfig((data) => {
      if (data?.[path]) {
        data[path][name] = event.target.checked;
      } else {
        data = {};
        data[path] = { [name]: event.target.checked };
      }
      return { ...data };
    });
  };

  return (
    <>
      <Paper elevation={0} sx={styles.card}>
        {children}
        <IconButtonCustom
          title={fullScreem ? "Sair da Tela Cheia" : "Tela Cheia"}
          iconOn={FullscreenIcon}
          iconOff={FullscreenExitIcon}
          variable={fullScreem}
          onclick={setFullScreem}
        />

        {tipo !== 1 && (
          <IconButtonCustom
            title={showLabel ? "Ocultar Detalhes" : "Mostrar detalhes"}
            iconOn={SubtitlesOutlinedIcon}
            iconOff={SubtitlesOffOutlinedIcon}
            variable={showLabel}
            onclick={setShowLabel}
          />
        )}
        {tipo === 1 && (
          <IconButtonCustom
            title={""}
            iconOn={LabelOutlined}
            iconOff={LabelOffOutlined}
            variable={showLabelEnlace}
            onclick={setShowLabelEnlace}
          />
        )}
        <IconButtonCustom
          title={"Ajustes"}
          iconOn={TuneOutlined}
          iconOff={TuneOutlined}
          variable={Boolean(anchorEl)}
          sendEvent={true}
          onclick={handleClick}
        />
        <IconButtonCustom
          title={
            soundState ? "Desativar sons de alerta" : "Ativar sons de alerta"
          }
          iconOn={VolumeUp}
          iconOff={VolumeOff}
          variable={soundState}
          sendEvent={true}
          onclick={() => {
            setSoundState((prev) => !prev);
          }}
        />
      </Paper>

      {/* <ConfigLocalPopover
        position={fullScreem ? { top: 170, left: 65 } : { top: 230, left: 375 }}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        setEasyMapsConfig={setEasyMapsConfig}
        easyMapsConfig={easyMapsConfig}
      /> */}
      <ConfiguracaoMapModal open={Boolean(anchorEl)} setOpen={handleClose} />
    </>
  );
};
const IconButtonCustom = ({
  title,
  iconOn: IconOn,
  iconOff: IconOff,
  variable,
  onclick = () => {},
  sendEvent = false,
}) => {
  let theme = useTheme();
  let styles = {
    // icon: {
    //   color: theme.palette.color.icons,
    // },
    button: {
      borderRadius: "5px",
      padding: "5px",
      boxShadow: "0px 0px 5px  #00000015",
      backgroundColor: theme.palette.background.paperSelectedMaps,
      "&:hover": { backgroundColor: theme.palette.background.hover },
    },
  };
  return (
    <Tooltip title={title} placement="right">
      <IconButton
        aria-label="custom-icon-button"
        sx={{
          ...styles.button,
          ...(variable
            ? {
                color: theme.palette.primary.main,
              }
            : {}),
        }}
        onClick={(event) => onclick(sendEvent ? event : !variable)}
      >
        <IconOn />
        {/* {!variable ? <IconOn /> : <IconOff sx={styles.icon} />} */}
      </IconButton>
    </Tooltip>
  );
};
const InputZoomTop = () => {
  const { zoomIn, zoomOut } = useReactFlow();
  const styles = {
    button: {
      borderRadius: "5px",
      padding: "5px",
    },
  };
  return (
    <Stack>
      <IconButtonCustom
        title={"Zoom In"}
        iconOn={AddIcon}
        iconOff={AddIcon}
        variable={false}
        onclick={() => zoomIn()}
      />
      <Divider sx={{ width: "80%", ml: "10%" }} />
      <IconButtonCustom
        title={"Zoom Out"}
        iconOn={RemoveIcon}
        iconOff={RemoveIcon}
        variable={false}
        onclick={() => zoomOut()}
      />
    </Stack>
  );
};
const InputZoomGeo = ({ zoom }) => {
  const styles = {
    button: {
      borderRadius: "5px",
      padding: "5px",
    },
  };
  return (
    <Stack>
      <IconButtonCustom
        title={"Zoom In"}
        iconOn={AddIcon}
        iconOff={AddIcon}
        variable={false}
        onclick={() => zoom(1)}
      />
      <Divider sx={{ width: "80%", ml: "10%" }} />
      <IconButtonCustom
        title={"Zoom Out"}
        iconOn={RemoveIcon}
        iconOff={RemoveIcon}
        variable={false}
        onclick={() => zoom(-1)}
      />
    </Stack>
  );
};
ToolBarMapsPublic.InputZoomGeo = InputZoomGeo;
ToolBarMapsPublic.InputZoomTop = InputZoomTop;
export default ToolBarMapsPublic;
